// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 11,
  argument: "",
  verses: [
    { n: 1, text: "A deceitful balance is an abomination before the Lord: and a just weight is his will." },
    { n: 2, text: "Where pride is, there also shall be reproach: but where humility is, there also is wisdom." },
    { n: 3, text: "The simplicity of the just shall guide them: and the deceitfulness of the wicked shall destroy them." },
    { n: 4, text: "Riches shall not profit in the day of revenge: but justice shall deliver from death." },
    { n: 5, text: "The justice of the upright shall make his way prosperous: and the wicked man shall fall by his own wickedness." },
    { n: 6, text: "The justice of the righteous shall deliver them: and the unjust shall be caught in their own snares." },
    { n: 7, text: "When the wicked man is dead, there shall be no hope any more: and the expectation of the solicitous shall perish." },
    { n: 8, text: "The just is delivered out of distress: and the wicked shall be given up for him." },
    { n: 9, text: "The dissembler with his mouth deceiveth his friend: but the just shall be delivered by knowledge." },
    { n: 10, text: "When it goeth well with the just, the city shall rejoice: and when the wicked perish, there shall be praise." },
    { n: 11, text: "By the blessing of the just the city shall be exalted: and by the mouth of the wicked it shall be overthrown." },
    { n: 12, text: "He that despiseth his friend, is mean of heart: but the wise man will hold his peace." },
    { n: 13, text: "He that walketh deceitfully, revealeth secrets: but he that is faithful, concealeth the thing committed to him by his friend." },
    { n: 14, text: "Where there is no governor, the people shall fall: but there is safety where there is much counsel." },
    { n: 15, text: "He shall be afflicted with evil, that is surety for a stranger: but he that is aware of the snares, shall be secure." },
    { n: 16, text: "A gracious woman shall find glory: and the strong shall have riches." },
    { n: 17, text: "A merciful man doth good to his own soul: but he that is cruel casteth off even his own kindred." },
    { n: 18, text: "The wicked maketh an unsteady work: but to him that soweth justice, there is a faithful reward." },
    { n: 19, text: "Clemency prepareth life: and the pursuing of evil things death." },
    { n: 20, text: "A perverse heart is abominable to the Lord: and his will is in them that walk sincerely." },
    { n: 21, text: "Hand in hand the evil man shall not be innocent: but the seed of the just shall be saved." },
    { n: 22, text: "A golden ring in a swine's snout, a woman fair and foolish." },
    { n: 23, text: "The desire of the just is all good, the expectation of the wicked is indignation." },
    { n: 24, text: "Some distribute their own goods, and grow richer: others take away what is not their own, and are always in want." },
    { n: 25, text: "The soul that blesseth, shall be made fat: and he that inebriateth, shall be inebriated also himself." },
    { n: 26, text: "He that hideth up corn, shall be cursed among the people: but a blessing upon the head of them that sell." },
    { n: 27, text: "Well doth he rise early who seeketh good things: but he that seeketh after evil things, shall be oppressed by them." },
    { n: 28, text: "He that trusteth in his riches shall fall: but the just shall spring up as a green leaf." },
    { n: 29, text: "He that troubleth his own house, shall inherit the winds: and the fool shall serve the wise." },
    { n: 30, text: "The fruit of the just man is a tree of life: and he that gaineth souls is wise." },
    { n: 31, text: "If the just man receive in the earth, how much more the wicked and the sinner?" },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Balance. Both in commerce, (Deuteronomy xxv. 13.; Calmet) and in passing sentence on others.", attribution: "Ven. Bede" }
    ] },
    { verse: 2, notes: [
      { text: "Wisdom. God resists the proud, chap. xvi. 18., and xviii. 12., and James iv. 6.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Solicitous. Or ambitious. Hebrew, \"the potent,\" or Septuagint, \"the impious.\"", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "For him. As comparatively nothing worth to his master, chap. xxi. 18., and Isaias xliii. 3", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Overthrown. Ten just men would have saved Sodom. Achan alone threw all Israel into confusion.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "Mean. Literally, \"indigent\" of sense. (Haydock) — We must put up with some faults, as none are without. (Horace i. Sat. 3.)", attribution: "Calmet" }
    ] },
    { verse: 13, notes: [
      { text: "Walketh. Septuagint, \"the double-tongued,\" dissembler, or great talker.", attribution: "Calmet" }
    ] },
    { verse: 15, notes: [
      { text: "That is. Hebrew, \"that hateth those who make agreements is secure.\"", attribution: "Mont.[Montanus?]" }
    ] },
    { verse: 16, notes: [
      { text: "Gracious. Virtuous and beautiful, as God hath granted beauty also for good purposes. This and virtue tend to the advancement of women, while men can use their strength to acquire riches. (Calmet) — Glory. Septuagint, Syriac, and Arabic add, \"of her husband. But she that hateth righteousness is a throne of disgrace. The slothful, though rich, shall come to poverty; but the laborious shall retain their riches.\" Two hemistics seem to be lost in Hebrew. (Kennicott) — Most of the additions in the Septuagint are only glosses, or useless repetitions, (Calmet) though they seem not to be so in this place.", attribution: "Haydock" }
    ] },
    { verse: 17, notes: [
      { text: "Kindred. Hebrew, \"flesh,\" Genesis xxix. 14. The miser is cruel even to himself.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "In hand. At rest, or making agreements. God will punish the race of the wicked.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Foolish. Beauty, without prudence, leads to ruin, as ornaments are ill bestowed on swine. The women in the east sometimes wore rings in their noses, (Genesis xxiv. 22.; Calmet) or hanging down upon them, Isaias iii. 21.", attribution: "Menochius" }
    ] },
    { verse: 24, notes: [
      { text: "Others. Moderation is always requisite. Hebrew, \"there is one withholding from rectitude, yet for a defect,\" (Mont.[Montanus?]) being too saving, he is a loser. (Haydock) — Avarice does not always increase riches.", attribution: "Calmet" }
    ] },
    { verse: 25, notes: [
      { text: "Himself. He shall receive abundantly, 2 Corinthians ix. 6. The beneficent shall be amply rewarded both in this world and in the next.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Corn. In times of scarcity. See Amos viii. 7.", attribution: "Haydock" }
    ] },
    { verse: 29, notes: [
      { text: "House. By his profligacy, or law-suits, shall be impoverished, (", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Life. Producing excellent fruits of virtue and edification.", attribution: "Haydock" }
    ] },
    { verse: 31, notes: [
      { text: "Receive. Punishment, for almost inevitable faults, or be treated according to his deserts. Septuagint, Syriac, and Arabic, \"if the just be hardly saved, where shall the impious and the sinner appear?\" (1 Peter iv. 18.) (Calmet) — Afflictions attend the just in this life. Shall the wicked escape?", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
